import React from "react";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { View } from "@common/types/views/views";
import {
    SendingEmailColumn,
    SendingEmailRow,
    sendingEmailsViewConfig,
} from "./sendingEmailsViewConfig";

const defaultView: View = {
    columns: [
        { id: SendingEmailColumn.EMAIL },
        { id: SendingEmailColumn.DISPLAY_NAME },
        { id: SendingEmailColumn.DOMAIN },
        { id: SendingEmailColumn.ENTITIES },
        { id: SendingEmailColumn.DEFAULT },
        { id: SendingEmailColumn.ACTIONS, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: false,
        bulkActions: false,
    },
};

interface SendingEmailsViewProps {
    data: SendingEmailRow[] | null;
}

export const SendingEmailsView: React.FC<SendingEmailsViewProps> = ({
    data,
}) => (
    <ViewTable
        data={data}
        view={defaultView}
        config={sendingEmailsViewConfig}
        emptyView={() => (
            <EmptyState
                header="No sender emails yet"
                body="Add a from address on a sending domain to use when Kick sends invoices."
            />
        )}
        enableColumnResizing={false}
        outerBorder
    />
);
